import React, { useMemo } from 'react';
import { usePerformanceStore } from '@modules/performance/store/store';
import { PerformanceFormComponent } from '@modules/performance/types';
import { EComponentTypes } from '@modules/learning/definitions';

// Reuse existing preview components from common
import TextComponent from '@common/components/form/user-response-fields/components/text';
import ImageComponent from '@common/components/form/user-response-fields/components/image';
import VideoComponent from '@common/components/form/user-response-fields/components/video';
import FileComponent from '@common/components/form/user-response-fields/components/file';

type Props = {
  item: PerformanceFormComponent;
};

type LearningComponent = {
  id: string;
  type: string;
  index: number;
  parameters?: Record<string, any>;
};

const getPreviewComponent = (type: string) => {
  switch (type) {
    case EComponentTypes.TEXT:
      return TextComponent;
    case EComponentTypes.IMAGE:
      return ImageComponent;
    case EComponentTypes.VIDEO:
    case EComponentTypes.EXTERNAL_VIDEO:
      return VideoComponent;
    case EComponentTypes.PDF:
      return FileComponent;
    default:
      return null;
  }
};

export const ContentModulePreview = ({ item }: Props) => {
  const { drafts } = usePerformanceStore();

  const components: LearningComponent[] = useMemo(() => {
    const draftItems = drafts?.[item.id]?.content_components;
    const settingsItems = (item as any)?.settings?.content_components;
    const settingsArray = (item as any)?.settings;

    // Handle both cases: settings can be an array OR an object with content_components
    const base = Array.isArray(draftItems)
      ? draftItems
      : Array.isArray(settingsItems)
      ? settingsItems
      : Array.isArray(settingsArray)
      ? settingsArray
      : [];
    return [...base].sort((a, b) => (a.index ?? 0) - (b.index ?? 0));
  }, [drafts, item]);

  if (!components || components.length === 0) return null;

  return (
    <div className="tw-flex tw-flex-col tw-gap-3">
      {components.map((comp) => {
        const Preview = getPreviewComponent(comp.type);
        if (!Preview) return null;
        // the common preview components expect an `item` prop with component data
        return (
          <div key={comp.id} className="tw-w-full">
            {(Preview as any)({ item: comp })}
          </div>
        );
      })}
    </div>
  );
};

export default ContentModulePreview;


